<template>
  <div id="app">
    <!-- <page-header /> -->
    <router-view/>
  </div>
</template>

<script>
// import PageHeader from '@/components/page-header'

export default {
  name: 'App',
  // components: { PageHeader }
}
</script>
